// Texte für den Relaunch 2026 (Struktur, Sprache, Bewegung).
// Grundlage: Konzept „Parto Website: Struktur, Sprache und Bewegung“, Wissensdatei Version 4,
// Vertriebspräsentation rev 05. Alle Aussagen ohne Zahlen; Kennzahlen erst nach Freigabe durch Parto.
// Sprachstand Oktober 2026: Version 2 sprachlich angehoben (klar, fachlich, selbstbewusst), „Bestandsliste“ einheitlich.

export const relaunch = {
    de: {
        nav: {
            how: "So arbeiten wir",
            stock: "Für Ihren Bestand",
            references: "Referenzen",
            about: "Über Parto",
            cta: "Bestand anfragen",
            stoererText: "Ungenutzte Bestände im Lager?",
            stoererCta: "Jetzt Kontakt aufnehmen",
            stoererClose: "Hinweis schließen",
            menu: "Menü öffnen",
            close: "Menü schließen",
            stockIntro: "Wählen Sie Ihre Ausgangslage.",
            stockAll: "Alle Bestandsarten",
            aboutIntro: "Wer hinter Parto steht.",
            stockItems: [
                { label: "Überbestände", desc: "Bestand über dem tatsächlichen Bedarf.", to: "/solutions/surplus-excess", img: "/media/parto/paletten-folie.jpg" },
                { label: "Ersatzteile", desc: "MRO Bestand für ersetzte oder stillgelegte Anlagen.", to: "/solutions/mro-spare-parts", img: "/media/parto/kugellager.jpg" },
                { label: "Veraltete Teile", desc: "Langsamdreher und abgekündigte Teile.", to: "/solutions/obsolete-slow-moving", img: "/media/parto/werkhalle-alt.jpg" },
                { label: "Werksschließung", desc: "Ganze Hallen termingerecht räumen.", to: "/solutions/plant-closures", img: "/media/parto/werkhalle-maschinen.jpg" },
            ],
            aboutItems: [
                { label: "Unternehmen", desc: "Wer wir sind und wofür wir stehen.", to: "/company" },
                { label: "Netzwerk und Kanäle", desc: "HubParto, Parto Assets und unsere Partner.", to: "/ecosystem" },
                { label: "Partner werden", desc: "Für Händler, Logistik und Verwertung.", to: "/partners" },
                { label: "Karriere", desc: "Offene Stellen bei Parto.", to: "/careers" },
            ],
        },
        flowSpace: { space: "Lagerfläche", used: "belegt", revenue: "Erlös", perWeek: "bisher", legendUsed: "Belegt", legendFree: "Frei geworden", freed: "Fläche frei", ariaLabel: "Animation: Fächer im Regal werden nach und nach frei, die Ware wird verkauft und der Erlös steigt." },
        flowClear: { plan: "Räumungsplan", hall: "Halle", handover: "Übergabe", handedShort: "übergeben", legendCapture: "Erfassen", legendSell: "Verkaufen", legendHand: "Übergabe", ariaLabel: "Animation: Drei Hallen werden nacheinander erfasst, verkauft und zum festen Termin übergeben." },
        flow: {
            listTitle: "Ihre Bestandsliste",
            listHint: "Excel, ERP Export oder formlose Aufstellung",
            items: [
                { name: "Servomotor", meta: "4 Stück", img: "servomotor", value: 380, route: 0 },
                { name: "Ventilinsel", meta: "12 Stück", img: "ventilinsel", value: 2450, route: 1 },
                { name: "Getriebe", meta: "1 Stück, defekt", img: "getriebe", value: 0, route: 2 },
            ],
            steps: ["Erfasst", "Bewertet", "Weg gewählt", "Abgerechnet"],
            chips: ["Foto und Typenschild", "Zustand geprüft", "Marktwert ermittelt"],
            routes: ["Einzelverkauf", "Ausschreibung", "Recycling"],
            done: "Abgerechnet",
            doneHint: "Jede Position einzeln nachvollziehbar",
            revenue: "Erlös bisher",
            proof: "Nachweis",
            stock: "Bestand",
            positions: "Positionen",
            sorted: "Parto sortiert",
            parts: "Teile",
            ariaLabel: "Animation: Ein Teil aus Ihrer Bestandsliste wird erfasst, bewertet, dem besten Weg zugeordnet und abgerechnet.",
        },
        home: {
            heroSlides: [
                { img: "/media/parto/werkhalle-ruhig.jpg", pos: "60% 50%", graphic: true, title: ["Bestände, die Sie", "nicht mehr brauchen?", "Parto übernimmt."], text: "Parto ist Ihre Komplettlösung für Überbestand. Von der Bestandsliste bis zur Auszahlung, alles aus einer Hand.", cta: "Bestand anfragen", to: "/contact", secondary: "So arbeiten wir", secondaryTo: "/how-it-works" },
                { img: "/media/parto/paletten-folie.jpg", pos: "70% 50%", graphic: "space", title: ["Aus Lagerfläche", "wird wieder Kapital."], text: "Wir verkaufen Ihren Überbestand Position für Position zum Marktpreis. Sie behalten jederzeit den vollen Überblick.", cta: "Bestand anfragen", to: "/contact?intent=assets&situation=surplus", secondary: "Überbestände", secondaryTo: "/solutions/surplus-excess" },
                { img: "/media/parto/werkhalle-maschinen.jpg", pos: "50% 50%", graphic: "clear", title: ["Ein Werk räumen,", "mit festem Termin."], text: "Wir erfassen, verkaufen und übergeben die Halle zum vereinbarten Termin. Ein Ansprechpartner für das gesamte Projekt.", cta: "Projekt anfragen", to: "/contact?intent=assets&situation=closure", secondary: "Werksschließung", secondaryTo: "/solutions/plant-closures" },
            ],
            heroEyebrow: "Parto Solution",
            heroTitle: ["Bestände, die Sie", "nicht mehr brauchen?", "Parto übernimmt."],
            heroSub: "Parto lagert und verkauft Überbestände, Ersatzteile und Maschinen zum bestmöglichen Erlös. Sie entscheiden nur, was in den Verkauf geht.",
            heroPrimary: "Bestand anfragen",
            heroSecondary: "So arbeiten wir",
            heroBrandLine: "The operating system for industrial assets.",
            problemLabel: "Das Problem",
            problemTitle: "In jedem Werk liegen Teile, die keiner mehr braucht.",
            problemText: "Sie belegen Fläche, binden Kapital und verlieren jeden Monat an Wert.",
            compareBefore: "Vorher",
            compareAfter: "Mit Parto",
            compareHint: "Regler ziehen: So sieht Ihr Lager aus, wenn Parto übernimmt.",
            compareAlt: "Vergleich: ein volles Lager und dasselbe Lager mit freien Regalen",
            problemFacts: [
                { title: "Gebundenes Kapital", text: "Liquidität steckt in Teilen, die niemand mehr nutzt." },
                { title: "Volle Lager", text: "Fläche fehlt für das Material, das Ihre Produktion wirklich braucht." },
                { title: "Hoher Aufwand", text: "Händler einzeln anzufragen kostet Zeit und erzielt selten den Marktpreis." },
            ],
            processLabel: "So arbeiten wir",
            processTitle: "Vier Schritte. Den ersten gehen Sie, den Rest übernimmt Parto.",
            processLink: "Ablauf im Detail",
            stockLabel: "Für Ihren Bestand",
            stockTitle: "Für jede Ausgangslage der passende Weg.",
            stockLink: "Alle Bestandsarten",
            stockMore: "Mehr erfahren",
            numbersLabel: "Parto in Zahlen",
            numbersTitle: "Ein Netzwerk, das Ihre Teile verlässlich an den Markt bringt.",
            routesLabel: "Der beste Weg für jedes Teil",
            routesTitle: "Nicht jedes Teil gehört auf denselben Marktplatz.",
            routesText: "Jede Position geht über den Kanal mit dem höchsten Erlös. Immer erst nach Ihrer Freigabe.",
            safetyLabel: "Ihre Sicherheit",
            safetyTitle: "Sie behalten die Kontrolle.",
            ctaTitle: "Welche Bestände binden bei Ihnen gerade Fläche und Kapital?",
            ctaText: "Senden Sie uns Ihre Bestandsliste oder einige Fotos. Sie erhalten eine fundierte erste Einschätzung.",
            ctaButton: "Bestand anfragen",
            ctaSecondary: "Erst mehr erfahren",
        },
        process: [
            { num: "01", title: "Bestandsliste senden", text: "Excel, ERP Export oder eine formlose Aufstellung. Vorarbeit ist nicht nötig." },
            { num: "02", title: "Bewerten und abstimmen", text: "Wir prüfen Marktwert und Nachfrage und empfehlen den Verkaufsweg. Die Entscheidung liegt bei Ihnen." },
            { num: "03", title: "Parto setzt um", text: "Wir übernehmen Erfassung, Einlagerung und Verkauf. Für Sie entsteht kein weiterer Aufwand." },
            { num: "04", title: "Abrechnung und Auszahlung", text: "Sie erhalten eine nachvollziehbare Abrechnung, jede Position einzeln nachvollziehbar." },
        ],
        routes: [
            { name: "Einzelverkauf", channel: "über HubParto und Plattformen", text: "Für Teile mit hoher Nachfrage. Jede Position wird einzeln zum Marktpreis angeboten." },
            { name: "Ausschreibung", channel: "über Parto Assets", text: "Für größere Posten und Maschinen. Geprüfte Händler geben Angebote ab, Sie entscheiden über den Zuschlag." },
            { name: "Recycling", channel: "dokumentiert", text: "Nur wenn ein Teil nicht mehr verkäuflich ist. Mit Nachweis für Ihre Dokumentation." },
        ],
        safety: [
            { title: "Das Eigentum bleibt bei Ihnen", text: "Parto erhält ausschließlich das Recht, die Ware zu verkaufen." },
            { title: "Nichts ohne Ihre Freigabe", text: "Sie entscheiden, was verkauft wird und über welchen Weg." },
            { title: "Rücknahme jederzeit", text: "Wird ein Teil doch wieder gebraucht, erhalten Sie es zurück." },
            { title: "Versichert gelagert", text: "Alle Waren in unserem Lager sind über Parto versichert." },
            { title: "Vertraulich", text: "Käufer und Händler erfahren nicht, von wem die Ware stammt." },
            { title: "Ein Ansprechpartner", text: "Für alle Wege, von der Bestandsliste bis zur Auszahlung." },
        ],
        how: {
            eyebrow: "So arbeiten wir",
            title: "Von der Bestandsliste bis zur Auszahlung.",
            sub: "Ein Ablauf, ein Ansprechpartner. Für den Start genügt Ihre Bestandsliste.",
            stepsLabel: "Der Ablauf",
            stepsTitle: "Vier Schritte mit klarer Aufgabenteilung.",
            youLabel: "Sie",
            partoLabel: "Parto",
            stepOwners: ["Sie", "Gemeinsam", "Parto", "Parto"],
            takeoverLabel: "Was Sie nicht mehr tun müssen",
            takeoverTitle: "Wir übernehmen die gesamte Arbeit rund um den Verkauf.",
            takeoverBefore: "Bisher bei Ihnen",
            takeoverAfter: "Übernimmt Parto",
            takeoverTasks: "Aufgaben",
            takeoverYou: "Für Sie bleibt",
            takeoverYouText: "Bestandsliste senden und freigeben. Mehr nicht.",
            takeover: [
                ["Händler suchen und anschreiben", "Marktansprache und aktiver Verkauf"],
                ["Preise vergleichen und verhandeln", "Preisermittlung und Verhandlung"],
                ["Plattformen einzeln betreuen", "Verkauf über alle Kanäle"],
                ["Versand und Logistik organisieren", "Lagerung, Logistik und Versand"],
                ["Rechnungen und Zahlungseingänge prüfen", "Abwicklung und Abrechnung"],
                ["Nachweise zusammenstellen", "Dokumentation und Recyclingnachweis"],
            ],
            routesLabel: "Wege in den Markt",
            routesTitle: "Für jedes Teil der Weg mit dem besten Erlös.",
            routesText: "Bringt ein Kanal nicht den erwarteten Erlös, wechseln wir in Abstimmung mit Ihnen.",
            transparencyLabel: "Transparenz",
            transparencyTitle: "Sie sehen jederzeit, wo jedes Teil steht.",
            transparency: [
                { title: "Status jeder Position", text: "Erfasst, angeboten, verkauft oder recycelt. Im Kundenportal jederzeit einsehbar." },
                { title: "Kosten und Erlös", text: "Alle Kosten und der Nettoerlös stehen offen gegenüber." },
                { title: "Monatliche Abrechnung", text: "Prüffähig für Buchhaltung und Controlling, jede Position einzeln." },
            ],
            safetyLabel: "Ihre Sicherheit",
            safetyTitle: "Klare Regeln von Anfang an.",
        },
        stock: {
            eyebrow: "Für Ihren Bestand",
            title: "Jeder Bestand ist anders. Der Ablauf bleibt einfach.",
            sub: "Wählen Sie Ihre Ausgangslage und sehen Sie, wie Parto vorgeht.",
            sortLabel: "Erst sortieren, dann verkaufen",
            sortTitle: "Kritische Teile bleiben. Der Rest bekommt einen Weg.",
            sortText: "Gemeinsam mit Ihnen trennen wir, was bleibt und was gehen darf. Die Versorgung Ihrer Anlagen bleibt gesichert.",
            sortGroups: ["Behalten", "Freigeben", "Verwerten"],
            sortItems: [
                { name: "Servomotor", meta: "4 Stück · seit 2019 unbewegt", img: "servomotor", group: 1, reason: "Kein Bedarf mehr, im Markt gefragt" },
                { name: "Elektromotor", meta: "2 Stück · Linie 2", img: "elektromotor", group: 0, reason: "Reserve für laufende Anlage" },
                { name: "Ventilinsel", meta: "12 Stück · Projektüberhang", img: "ventilinsel", group: 1, reason: "Neuwertig, originalverpackt" },
                { name: "Wälzlager", meta: "40 Stück · Instandhaltung", img: "waelzlager", group: 0, reason: "Kritisch, lange Lieferzeit" },
                { name: "Zahnrad", meta: "18 Stück · abgekündigt", img: "zahnrad", group: 1, reason: "Gesucht für Altanlagen" },
                { name: "Getriebe", meta: "1 Stück · defekt", img: "getriebe", group: 2, reason: "Reparatur unwirtschaftlich" },
                { name: "Flansch", meta: "6 Stück · Sonderteil", img: "flansch", group: 1, reason: "Händler im Netzwerk interessiert" },
            ],
            sortListTitle: "Bestandsliste",
            sortChecked: "geprüft",
            sortPending: "Ungeprüft",
            sortSummary: "Ergebnis der Prüfung",
            sortAgain: "Erneut prüfen",
            cardsLabel: "Ausgangslagen",
            cardsTitle: "Wählen Sie Ihre Ausgangslage.",
            cards: [
                { title: "Überbestände", text: "Mehr auf Lager als nötig. Wir bringen den Überschuss zurück in den Markt.", to: "/solutions/surplus-excess", img: "/media/parto/paletten-folie.jpg" },
                { title: "Ersatzteile", text: "Kritische Teile sichern, echten Überschuss freigeben.", to: "/solutions/mro-spare-parts", img: "/media/parto/kugellager.jpg" },
                { title: "Veraltete Teile", text: "Langsamdreher und abgekündigte Teile. Wir erzielen den Restwert.", to: "/solutions/obsolete-slow-moving", img: "/media/parto/werkhalle-alt.jpg" },
                { title: "Werksschließung", text: "Ein Standort schließt oder zieht um. Wir räumen nach festem Zeitplan.", to: "/solutions/plant-closures", img: "/media/parto/werkhalle-maschinen.jpg" },
            ],
            more: "Mehr erfahren",
            rolesLabel: "Für Ihre Rolle",
            rolesTitle: "Was das für Sie bedeutet.",
            roles: [
                { title: "Einkauf und Materialwirtschaft", text: "Weniger Überbestand, mehr Transparenz. Ersatzteile beschaffen Sie über HubParto günstiger." },
                { title: "Instandhaltung", text: "Kritische Teile bleiben verfügbar. Freigegeben wird nur echter Überschuss." },
                { title: "Finanzen und Controlling", text: "Gebundenes Kapital wird wieder zu Liquidität. Mit nachvollziehbarer Abrechnung je Position." },
                { title: "Werksleitung und Geschäftsführung", text: "Fläche wird frei, Ihre Mitarbeiter werden entlastet. Ein Ansprechpartner für das gesamte Projekt." },
            ],
            directLabel: "Direkt verkaufen",
            directLinks: [
                { label: "Industriebestand verkaufen", to: "/solutions/sell-industrial-inventory" },
                { label: "Überbestand verkaufen", to: "/solutions/sell-surplus-inventory" },
                { label: "Maschinen und Anlagen verkaufen", to: "/solutions/sell-machinery-equipment" },
                { label: "Standort und Werk räumen", to: "/solutions/plant-closures-restructuring" },
            ],
        },
        references: {
            eyebrow: "Referenzen",
            title: "Referenzen stellen wir Ihnen persönlich vor.",
            sub: "Unsere Kunden bleiben anonym. Projekte zeigen wir nur mit deren Zustimmung, im persönlichen Gespräch gehen wir gern ins Detail.",
            cta: "Referenzen anfragen",
            numbersLabel: "Parto in Zahlen",
            numbersTitle: "Was hinter unserem Netzwerk steht.",
            casesLabel: "Beispielprojekte",
            casesTitle: "Vier Projekte aus der Praxis, anonymisiert.",
            cases: [
                { tag: "Werksschließung", title: "Ein Werk termingerecht geräumt.", text: "Drei Hallen erfasst, verkauft und besenrein übergeben.", img: "/media/parto/werkhalle-maschinen.jpg", facts: [] },
                { tag: "Ersatzteillager", title: "Lager bereinigt, Anlagen gesichert.", text: "Gemeinsam mit der Instandhaltung geprüft. Kritische Teile blieben, der Überschuss ging in den Verkauf.", img: "/media/parto/pruefen-messschieber.jpg", facts: [] },
                { tag: "Überbestand", title: "Altes Material, neue Käufer.", text: "Material für ein Jahr, frei geworden durch eine Produktumstellung. Verkauft an Käufer in ganz Europa.", img: "/media/parto/paletten-halle.jpg", facts: [] },
                { tag: "Altbestand", title: "Abgekündigte Steuerungen verkauft.", text: "Steuerungen und Antriebe, die nicht mehr hergestellt werden. Gefragt bei Betrieben mit älteren Anlagen.", img: "/media/parto/komponenten.jpg", facts: [] },
            ],
            casesNote: "Beispielprojekte ohne Kundennamen. Zahlen vorläufig, Freigabe ausstehend.",
            productsLabel: "Was wir an den Markt bringen",
            productsTitle: "Vom einzelnen Sensor bis zur ganzen Anlage.",
            products: [
                "SPS und Steuerungstechnik",
                "HMI und Bedienpanels",
                "Frequenzumrichter und Antriebstechnik",
                "Servomotoren und Elektromotoren",
                "Sensorik",
                "Pneumatik",
                "Industrierechner und Elektronik",
                "Netzteile und Maschinenersatzteile",
                "Robotik",
                "Maschinen und Anlagen",
            ],
            situationsLabel: "Typische Projekte",
            situationsTitle: "Aus diesen Situationen entstehen unsere Aufträge.",
            situations: [
                { title: "Überbestand nach Produktionsumstellung", text: "Material für ein ausgelaufenes Produkt liegt noch im Lager und geht zurück in den Markt." },
                { title: "Ersatzteillager bereinigen", text: "Über Jahre gewachsene Bestände werden gesichtet. Kritisches bleibt, Überschuss wird verkauft." },
                { title: "Altbestand aus der Automatisierung", text: "Abgekündigte Steuerungen und Antriebe finden Käufer, die genau diese Teile noch brauchen." },
                { title: "Standort räumen", text: "Maschinen und Teile werden erfasst und nach festem Zeitplan abgewickelt." },
            ],
            note: "Freigegebene Projekte veröffentlichen wir hier mit Zustimmung unserer Kunden.",
        },
        about: {
            eyebrow: "Über Parto",
            title: "Industrieteile sollen ihren Wert behalten.",
            sub: "Auch dann, wenn ein Unternehmen sie nicht mehr braucht. Parto verbindet Marktplätze, Lager und Daten und findet für jedes Teil den besten Weg.",
            quote: "Wir fangen dort an, wo andere aufhören.",
            quoteBy: "Artur Schlee · Geschäftsführer",
            valuesLabel: "Wie wir arbeiten",
            valuesTitle: "Fünf Werte, an denen Sie uns messen können.",
            values: [
                { title: "In Systemen denken", text: "Wir betrachten den gesamten Ablauf, bevor wir ein Angebot machen." },
                { title: "Nah am Teil bleiben", text: "Wir sehen uns Bestände vor Ort an und bewerten nur, was wir kennen." },
                { title: "Der Erlös zählt", text: "Wir empfehlen den besten Weg und sagen offen, wenn sich ein Verkauf nicht lohnt." },
                { title: "Wiederholbar arbeiten", text: "Was im ersten Projekt funktioniert, wird zum Standard für das nächste." },
                { title: "Alles offen legen", text: "Jeden Schritt, jede Bewertung und jede Entscheidung können Sie nachvollziehen." },
            ],
            networkLabel: "Parto Netzwerk",
            networkTitle: "Vier Marken, ein Ablauf.",
            networkText: "Welche Marke zum Einsatz kommt, entscheidet das Teil. Erst der Wert, dann der Kanal.",
            brands: [
                { name: "Parto Solution", role: "Übernahme", text: "Übernimmt freigegebene Bestände, erfasst sie und steuert den weiteren Weg.", href: null },
                { name: "HubParto", role: "Onlineshop", text: "Automatisierungstechnik und Ersatzteile ab Lager, für Geschäftskunden weltweit.", href: "https://hubparto.com/" },
                { name: "Parto Assets", role: "Ausschreibungen", text: "Geschlossene Ausschreibungen für Maschinen, Anlagen und Posten an geprüfte Händler.", href: "https://partoassets.com/" },
                { name: "BuyParto", role: "Ankauf", text: "Sofortankauf, wenn es schnell gehen soll. Festpreis und Abholung bei Ihnen.", href: "https://www.buyparto.com/" },
            ],
            teamLabel: "Wer dahinter steht",
            teamTitle: "Erfahrung aus der Industrie, mit Sitz im Münsterland.",
            leadLabel: "Geschäftsführung",
            leads: ["Artur Schlee", "Paul Seemann"],
            locationLabel: "Standort",
            location: "Stadtforst 3 · 48432 Rheine",
            moreLabel: "Mehr über Parto",
        },
        network: {
            eyebrow: "Netzwerk und Kanäle",
            title: "Vier Wege in den Markt. Ein Ansprechpartner.",
            sub: "Einzeln über HubParto, per Ausschreibung über Parto Assets, als Sofortankauf über BuyParto oder über unser Partnernetzwerk.",
            channelsLabel: "Unsere Kanäle",
            channelsTitle: "Für jedes Teil der passende Marktplatz.",
            channels: [
                { name: "HubParto", role: "Onlineshop", text: "Automatisierungstechnik und Ersatzteile ab Lager, weltweit für Geschäftskunden.", fit: "Für gefragte Einzelteile", img: "/media/parto/paket.jpg", href: "https://hubparto.com/" },
                { name: "Parto Assets", role: "Ausschreibungen", text: "Geschlossene Ausschreibungen für Maschinen, Anlagen und größere Posten.", fit: "Für Posten und Maschinen", img: "/media/parto/paletten-rampe.jpg", href: "https://partoassets.com/" },
                { name: "BuyParto", role: "Ankauf", text: "Unsere Marke für den Sofortankauf. BuyParto kauft Bestände direkt an, zum Festpreis und mit Abholung.", fit: "Wenn es schnell gehen soll", img: "/media/parto/stapler-verladung.jpg", href: "https://www.buyparto.com/" },
                { name: "Parto Netzwerk", role: "Partner", text: "Händler, Logistiker und Verwertungspartner, die eng mit uns zusammenarbeiten.", fit: "Für alles, was einen Spezialisten braucht", img: "/media/parto/stapler-transporter.jpg", to: "/partners" },
            ],
            visit: "Ansehen",
            principleLabel: "Unser Grundsatz",
            principleTitle: "Erst der Wert, dann der Kanal.",
            principleText: "Zustand, Nachfrage und erzielbarer Erlös bestimmen, wo ein Teil verkauft wird.",
            partnerTitle: "Sie wollen Teil des Netzwerks werden?",
            partnerText: "Für Händler, Einkäufer, Logistik und Verwertung.",
            partnerCta: "Partner werden",
        },
        partners: {
            eyebrow: "Partner werden",
            title: "Gemeinsam mehr Teile zurück in den Markt bringen.",
            sub: "Für Händler, Einkäufer, Logistik und Verwertung. Geprüfte Ware für verlässliche Partner.",
            cta: "Zur Anfrage",
            typesLabel: "Für wen",
            typesTitle: "Vier Arten der Zusammenarbeit.",
            types: [
                { id: "sales", title: "Vertrieb und Handel", text: "Sie verkaufen Industrieteile und suchen Zugang zu mehr Ware." },
                { id: "buyer", title: "Händler und Einkäufer", text: "Sie kaufen gebrauchte oder überschüssige Teile und möchten bei Ausschreibungen mitbieten." },
                { id: "logistics", title: "Logistik", text: "Sie transportieren, lagern oder verpacken Industriegüter." },
                { id: "recovery", title: "Verwertung", text: "Sie recyceln nicht mehr verkäufliche Teile fachgerecht und mit Nachweis." },
            ],
            choose: "Anfrage stellen",
            stepsLabel: "So läuft es",
            stepsTitle: "In vier Schritten zur Zusammenarbeit.",
            steps: [
                { num: "01", title: "Anfrage senden", text: "Sie füllen das kurze Formular unten aus." },
                { num: "02", title: "Kennenlernen", text: "Wir sprechen über Ihr Angebot, Ihre Märkte und Ihren Bedarf." },
                { num: "03", title: "Starten", text: "Gemeinsam legen wir fest, wie wir zusammenarbeiten." },
                { num: "04", title: "Zusammenarbeiten", text: "Sie erhalten passende Ware, Anfragen oder Aufträge." },
            ],
            formLabel: "Ihre Anfrage",
            formTitle: "Erzählen Sie uns kurz von Ihrem Unternehmen.",
            formText: "Wir melden uns persönlich bei Ihnen.",
        },
        careers: {
            detail: {
                back: "Alle Stellen",
                mission: "Ihre Aufgabe",
                own: "Das übernehmen Sie",
                bring: "Das bringen Sie mit",
                nice: "Von Vorteil",
                expect: "Das erwartet Sie",
                process: "So läuft die Bewerbung",
                processSteps: ["Bewerbung", "Erstes Gespräch", "Kennenlernen vor Ort", "Entscheidung"],
                apply: "Bewerben",
                applyTitle: "Klingt nach Ihnen?",
                applyText: "Ein paar Zeilen und Ihr Lebenslauf genügen. Ein Anschreiben brauchen wir nicht.",
                words: { "Full-Time": "Vollzeit", "Part-Time": "Teilzeit", Commercial: "Vertrieb", "Responsibility from Day One": "Verantwortung ab dem ersten Tag" },
            },
            eyebrow: "Karriere",
            title: "Arbeiten, wo Industrieteile ein zweites Leben bekommen.",
            sub: "Parto wächst. Wir suchen Menschen, die anpacken und Verantwortung übernehmen. In Rheine.",
            cta: "Offene Stellen",
            whyLabel: "Warum Parto",
            whyTitle: "Was Sie bei uns erwartet.",
            why: [
                { title: "Echte Verantwortung", text: "Sie gestalten Abläufe mit, die es in dieser Form noch nicht gibt." },
                { title: "Nah an der Praxis", text: "Lager, Kunden und Markt: Sie sehen jeden Tag, was Ihre Arbeit bewirkt." },
                { title: "Ein Team, das zusammenhält", text: "Kurze Wege, klare Absprachen und ein gemeinsames Ziel." },
            ],
            jobsLabel: "Offene Stellen",
            jobsTitle: "Hier suchen wir aktuell Verstärkung.",
            jobMore: "Zur Stelle",
            openTitle: "Nichts Passendes dabei?",
            openText: "Senden Sie uns eine Initiativbewerbung. Wir melden uns bei Ihnen.",
            openCta: "Initiativ bewerben",
        },
        contact: {
            eyebrow: "Kontakt",
            title: "Erzählen Sie uns, worum es geht.",
            sub: "Wenige Angaben genügen. Sie erhalten von uns eine fundierte erste Einschätzung.",
            intentLabel: "Ihr Anliegen",
            intentTitle: "Wobei können wir helfen?",
            intents: [
                { id: "assets", name: "Bestand", title: "Ich möchte Bestand abgeben.", desc: "Überbestand, Altbestand, Ersatzteile oder ein ganzer Standort.", chips: ["Überbestand", "Altbestand", "Ersatzteile", "Werk"], cta: "Bestand anfragen" },
                { id: "operations", name: "Abwicklung", title: "Ich brauche Unterstützung bei Lager und Abwicklung.", desc: "Erfassen, lagern, verpacken, versenden. Wir übernehmen die operative Arbeit rund um Ihren Bestand.", chips: ["Erfassung", "Lagerung", "Versand"], cta: "Abwicklung anfragen" },
                { id: "partnership", name: "Partnerschaft", title: "Ich möchte mit Parto zusammenarbeiten.", desc: "Als Händler, Käufer, Logistiker oder Verwerter.", chips: ["Handel", "Einkauf", "Logistik", "Verwertung"], cta: "Partner werden" },
                { id: "general", name: "Allgemein", title: "Ich habe eine andere Frage.", desc: "Presse, Lieferanten oder ein anderes Anliegen.", chips: [], cta: "Nachricht senden" },
            ],
            contactSection: "Ihre Kontaktdaten",
            situationSection: "Ihre Ausgangslage",
            situations: [
                { id: "surplus", label: "Überbestand" },
                { id: "obsolete", label: "Altbestand und Langsamdreher" },
                { id: "mro", label: "Ersatzteile" },
                { id: "closure", label: "Werk schließt oder wird umgebaut" },
                { id: "transfer", label: "Produktion zieht um" },
                { id: "other", label: "Etwas anderes" },
            ],
            assetTypesLabel: "Welche Teile sind dabei?",
            assetTypes: ["Automatisierung", "Elektrotechnik", "Antriebe und Motoren", "Mechanik", "Ersatzteile", "Maschinen und Anlagen", "Gemischt", "Sonstiges"],
            releasedLabel: "Ist der Bestand intern bereits freigegeben?",
            opsNeedsLabel: "Wobei sollen wir unterstützen?",
            opsNeeds: ["Übernahme", "Erfassung", "Aufbereitung", "Lagerung", "Bestandsführung", "Verpackung", "Versand", "Mehrere Kanäle", "Wareneingang und Ausgang", "Sonstiges"],
            uploadTitle: "Bestandsliste vorhanden?",
            uploadClaim: "Laden Sie Ihre Bestandsliste oder Fotos hoch.",
            uploadDesc: "Excel, ERP Export oder Fotos genügen.",
            uploadCta: "Dateien auswählen",
            uploadHint: "XLSX, XLS, CSV, PDF, DOCX, JPG, PNG · bis 10 MB je Datei · höchstens 5 Dateien",
            uploadNote: "Für die erste Einschätzung genügen die wichtigsten Angaben.",
            messagePhGeneral: "Worum geht es?",
            sending: "Wird gesendet",
            successTitle: "Vielen Dank, Ihre Anfrage ist eingegangen.",
            successText: "Wir prüfen Ihre Angaben und melden uns mit einer ersten Einschätzung.",
            wayLabel: "Was ist Ihnen wichtiger?",
            ways: [
                { id: "sale", title: "Höchster Erlös", desc: "Verkauf im Auftrag über Parto" },
                { id: "buy", title: "Schnelle Auszahlung", desc: "Sofortankauf über BuyParto" },
                { id: "advice", title: "Beraten Sie mich", desc: "Wir empfehlen Ihnen den passenden Weg" },
            ],
            wayPrefix: "Weg",
            wayLines: { sale: "Verkauf im Auftrag über Parto (höchster Erlös)", buy: "Sofortankauf über BuyParto", advice: "Beratung gewünscht" },
            successBuy: "Ihre Anfrage geht direkt an das Ankaufteam von BuyParto.",
            partnerLabel: "Partnerschaft",
            partnerTitle: "Wie möchten Sie mit uns arbeiten?",
            partnerCards: [
                { id: "sales", name: "Vertrieb und Handel", tagline: "Sie verkaufen Industrieteile und suchen mehr Ware." },
                { id: "buyer", name: "Händler und Einkäufer", tagline: "Sie suchen gebrauchte oder überschüssige Teile." },
                { id: "logistics", name: "Logistik", tagline: "Sie transportieren, lagern oder verpacken." },
                { id: "recovery", name: "Verwertung", tagline: "Sie recyceln fachgerecht und mit Nachweis." },
            ],
            partnerCta: "Direkt zur Anfrage",
            directLabel: "Lieber direkt?",
            directTitle: "Schreiben Sie uns.",
            locationLabel: "Standort",
            locationTitle: "Lager, Aufbereitung und Ansprechpartner an einem Ort.",
            entLabel: "Mehrere Standorte",
            entTitle: "Für größere Programme planen wir gemeinsam.",
            entDesc: "Mehrere Werke oder wiederkehrende Bestände? Wir legen ein einheitliches Vorgehen für jeden Standort fest.",
            entCta: "Programm besprechen",
            fields: { websitePh: "https://… (optional)", phonePh: "+49 5971 9629031" },
            funnel: { labelSituation: "Ausgangslage", labelAssetTypes: "Teile", intentHint: "Bitte wählen Sie zuerst ein Anliegen.", detailsHint: "Bitte füllen Sie die Pflichtfelder aus." },
        },
        routeMap: {
            source: "Freigegebene Bestände",
            gate: "Parto",
            gateSub: "findet für jedes Teil den besten Weg",
            channels: [
                { brand: "HubParto", name: "HubParto", sub: "Einzelverkauf" },
                { brand: "Parto Assets", name: "Parto Assets", sub: "Größere Posten" },
                { brand: "BuyParto", name: "BuyParto", sub: "Ankauf" },
                { name: "Netzwerk", sub: "Händler und Partner" },
                { name: "Verwertung", sub: "Recycling mit Nachweis" },
            ],
            aria: "Animation: Teile aus freigegebenen Beständen laufen über Parto in die passenden Kanäle: HubParto, Parto Assets, BuyParto, Netzwerk und Verwertung.",
        },
        testimonials: {
            label: "Kundenstimmen",
            title: "Was unsere Kunden sagen.",
            ratingLabel: "Gesamtbewertung",
            clientsLabel: "Referenzen",
            clientsTitle: "Diese Unternehmen arbeiten mit Parto.",
            logoPlaceholder: "Logo",
            clientsEyebrow: "Unternehmen, die mit Parto arbeiten",
            clientsNote: "Platzhalter: rechtliche Freigabe vonnöten.",
            of5: "von 5 Sternen",
            from: "aus",
            reviews: "Bewertungen",
            carousel: "Karussell",
            slide: "Folie",
            pause: "Bildfolge anhalten",
            play: "Bildfolge starten",
            prev: "Vorherige Folie",
            next: "Nächste Folie",
            pauseTicker: "Laufband anhalten",
            playTicker: "Laufband starten",
            placeholderNote: "Platzhalter: Stimmen, Bewertung und Logos werden nach Freigabe durch die Kunden ersetzt.",
        },
        footer: {
            tagline: "Parto übernimmt Lagerung und Verkauf von Industriebeständen, die Sie nicht mehr brauchen.",
            colHow: "Ablauf",
            howLinks: [
                { label: "So arbeiten wir", to: "/how-it-works" },
                { label: "Wege in den Markt", to: "/how-it-works#wege" },
                { label: "Ihre Sicherheit", to: "/how-it-works#sicherheit" },
                { label: "Referenzen", to: "/references" },
            ],
            colStock: "Für Ihren Bestand",
            colSell: "Direkt verkaufen",
            colAbout: "Über Parto",
            contact: "Kontakt",
            colChannels: "Unsere Kanäle",
            bottomLine: "Industriebestände sinnvoll weiterführen.",
        },
        titles: {
            "/how-it-works": "So arbeiten wir",
            "/solutions": "Für Ihren Bestand",
            "/references": "Referenzen",
            "/company": "Über Parto",
            "/sustainability": "Nachhaltigkeit und Kreislaufwirtschaft",
            "/brands": "Markenfamilie",
            "/location": "Standort und Lager",
            "/quality": "Qualität und Sicherheit",
            "/services": "Leistungen",
            "/industries": "Branchen",
            "/news": "Presse und Neuigkeiten",
            "/": "Industriebestände professionell verkaufen",
            "/ecosystem": "Netzwerk und Kanäle",
            "/partners": "Partner werden",
            "/careers": "Karriere",
            "/solutions/surplus-excess": "Überbestände",
            "/solutions/mro-spare-parts": "Ersatzteile",
            "/solutions/obsolete-slow-moving": "Veraltete Teile",
            "/solutions/plant-closures": "Werksschließung",
            "/solutions/sell-industrial-inventory": "Industriebestand verkaufen",
            "/solutions/sell-surplus-inventory": "Überbestand verkaufen",
            "/solutions/sell-machinery-equipment": "Maschinen und Anlagen verkaufen",
            "/solutions/plant-closures-restructuring": "Standort und Werk räumen",
            "/contact": "Kontakt",
            "/impressum": "Impressum",
            "/datenschutz": "Datenschutz",
            "/llm-info": "Informationen für KI Systeme",
        },
        notFound: {
            eyebrow: "Fehler 404",
            title: "Diese Seite gibt es nicht.",
            text: "Möglicherweise hat sich die Adresse geändert. Diese Seiten helfen weiter:",
            home: "Zur Startseite",
        },
    },

    en: {
        nav: {
            how: "How we work",
            stock: "Your inventory",
            references: "References",
            about: "About Parto",
            cta: "Request a review",
            stoererText: "Idle stock in your warehouse?",
            stoererCta: "Get in touch now",
            stoererClose: "Close notice",
            menu: "Open menu",
            close: "Close menu",
            stockIntro: "Choose your starting point.",
            stockAll: "All inventory types",
            aboutIntro: "The people behind Parto.",
            stockItems: [
                { label: "Surplus stock", desc: "Inventory beyond your actual demand.", to: "/solutions/surplus-excess", img: "/media/parto/paletten-folie.jpg" },
                { label: "Spare parts", desc: "MRO stock for replaced or decommissioned equipment.", to: "/solutions/mro-spare-parts", img: "/media/parto/kugellager.jpg" },
                { label: "Obsolete parts", desc: "Slow movers and discontinued parts.", to: "/solutions/obsolete-slow-moving", img: "/media/parto/werkhalle-alt.jpg" },
                { label: "Plant closure", desc: "Clear entire halls on schedule.", to: "/solutions/plant-closures", img: "/media/parto/werkhalle-maschinen.jpg" },
            ],
            aboutItems: [
                { label: "Company", desc: "Who we are and what we stand for.", to: "/company" },
                { label: "Network and channels", desc: "HubParto, Parto Assets and our partners.", to: "/ecosystem" },
                { label: "Become a partner", desc: "For dealers, logistics and recycling.", to: "/partners" },
                { label: "Careers", desc: "Open positions at Parto.", to: "/careers" },
            ],
        },
        flowSpace: { space: "Storage space", used: "in use", revenue: "Revenue", perWeek: "so far", legendUsed: "In use", legendFree: "Freed up", freed: "Space freed", ariaLabel: "Animation: shelf slots are freed one by one, goods are sold and revenue rises." },
        flowClear: { plan: "Clearance plan", hall: "Hall", handover: "Handover", captured: "Positions captured", sold: "Sold", handed: "Halls handed over", handedShort: "handed over", legendCapture: "Capture", legendSell: "Sell", legendHand: "Handover", ariaLabel: "Animation: three halls are captured, sold and handed over by a fixed date one after another." },
        flow: {
            listTitle: "Your inventory list",
            listHint: "Excel, ERP export or a simple overview",
            items: [
                { name: "Servo motor", meta: "4 units", img: "servomotor", value: 380, route: 0 },
                { name: "Valve terminal", meta: "12 units", img: "ventilinsel", value: 2450, route: 1 },
                { name: "Gearbox", meta: "1 unit, defective", img: "getriebe", value: 0, route: 2 },
            ],
            steps: ["Captured", "Assessed", "Route chosen", "Settled"],
            chips: ["Photo and type plate", "Condition checked", "Market value set"],
            routes: ["Single sale", "Tender", "Recycling"],
            done: "Settled",
            doneHint: "Every position traceable",
            revenue: "Revenue so far",
            proof: "Certificate",
            stock: "Stock",
            positions: "positions",
            sorted: "Parto sorts",
            parts: "parts",
            ariaLabel: "Animation: a part from your inventory list is captured, assessed, assigned to the best route and settled.",
        },
        home: {
            heroSlides: [
                { img: "/media/parto/werkhalle-ruhig.jpg", pos: "60% 50%", graphic: true, title: ["Stock you", "no longer need?", "Parto takes over."], text: "Parto is your complete solution for surplus stock. From inventory list to payout, everything from one source.", cta: "Request a review", to: "/contact", secondary: "How we work", secondaryTo: "/how-it-works" },
                { img: "/media/parto/paletten-folie.jpg", pos: "70% 50%", graphic: "space", title: ["Warehouse space", "turns into capital."], text: "We sell your surplus position by position at market price. You keep full visibility at all times.", cta: "Request a review", to: "/contact?intent=assets&situation=surplus", secondary: "Surplus stock", secondaryTo: "/solutions/surplus-excess" },
                { img: "/media/parto/werkhalle-maschinen.jpg", pos: "50% 50%", graphic: "clear", title: ["Clear a plant,", "on a fixed date."], text: "We capture, sell and hand over the hall on the agreed date. One point of contact for the entire project.", cta: "Request a project", to: "/contact?intent=assets&situation=closure", secondary: "Plant closure", secondaryTo: "/solutions/plant-closures" },
            ],
            heroEyebrow: "Parto Solution",
            heroTitle: ["Stock you", "no longer need?", "Parto takes over."],
            heroSub: "Parto stores and sells surplus stock, spare parts and machinery for the best possible return. You only decide what goes up for sale.",
            heroPrimary: "Request a review",
            heroSecondary: "How we work",
            heroBrandLine: "The operating system for industrial assets.",
            problemLabel: "The problem",
            problemTitle: "Every plant holds parts nobody needs anymore.",
            problemText: "They occupy space, tie up capital and lose value every month.",
            compareBefore: "Before",
            compareAfter: "With Parto",
            compareHint: "Drag the slider: this is your warehouse once Parto takes over.",
            compareAlt: "Comparison: a full warehouse and the same warehouse with free shelves",
            problemFacts: [
                { title: "Tied up capital", text: "Liquidity sits in parts nobody uses anymore." },
                { title: "Full warehouses", text: "Space is missing for the material your production really needs." },
                { title: "High effort", text: "Approaching dealers one by one takes time and rarely achieves market price." },
            ],
            processLabel: "How we work",
            processTitle: "Four steps. You take the first, Parto handles the rest.",
            processLink: "The process in detail",
            stockLabel: "Your inventory",
            stockTitle: "The right route for every situation.",
            stockLink: "All inventory types",
            stockMore: "Learn more",
            numbersLabel: "Parto in numbers",
            numbersTitle: "A network that reliably brings your parts to market.",
            routesLabel: "The best route for every part",
            routesTitle: "Not every part belongs on the same marketplace.",
            routesText: "Every position goes through the channel with the highest return. Always after your approval.",
            safetyLabel: "Your security",
            safetyTitle: "You stay in control.",
            ctaTitle: "Which stock is tying up space and capital in your plant right now?",
            ctaText: "Send us your inventory list or a few photos. You will receive a well founded first assessment.",
            ctaButton: "Request a review",
            ctaSecondary: "Learn more first",
        },
        process: [
            { num: "01", title: "Send your inventory list", text: "An Excel file, an ERP export or a simple overview. No preparation needed." },
            { num: "02", title: "Assess and agree", text: "We check market value and demand and recommend the sales route. The decision is yours." },
            { num: "03", title: "Parto executes", text: "We handle capture, storage and sale. No further effort on your side." },
            { num: "04", title: "Settlement and payout", text: "You receive an auditable statement, with every position traceable." },
        ],
        routes: [
            { name: "Single sale", channel: "via HubParto and platforms", text: "For parts in high demand. Every position is offered individually at market price." },
            { name: "Tender", channel: "via Parto Assets", text: "For larger lots and machinery. Verified dealers submit offers, you decide on the award." },
            { name: "Recycling", channel: "documented", text: "Only when a part can no longer be sold. With proof for your records." },
        ],
        safety: [
            { title: "Ownership stays with you", text: "Parto only receives the right to sell the goods." },
            { title: "Nothing without your approval", text: "You decide what is sold and through which route." },
            { title: "Take back at any time", text: "If you need a part again, you get it back." },
            { title: "Insured storage", text: "All goods in our warehouse are insured by Parto." },
            { title: "Confidential", text: "Buyers and dealers do not learn where the goods come from." },
            { title: "One point of contact", text: "For every route, from inventory list to payout." },
        ],
        how: {
            eyebrow: "How we work",
            title: "From your inventory list to the payout.",
            sub: "One process, one point of contact. Your inventory list is all it takes to start.",
            stepsLabel: "The process",
            stepsTitle: "Four steps, clearly assigned.",
            youLabel: "You",
            partoLabel: "Parto",
            stepOwners: ["You", "Together", "Parto", "Parto"],
            takeoverLabel: "What you no longer have to do",
            takeoverTitle: "We take over all the work around the sale.",
            takeoverBefore: "Until now with you",
            takeoverAfter: "Handled by Parto",
            takeoverTasks: "tasks",
            takeoverYou: "What stays with you",
            takeoverYouText: "Send your inventory list and approve. That is all.",
            takeover: [
                ["Finding and contacting dealers", "Market outreach and active selling"],
                ["Comparing and negotiating prices", "Pricing and negotiation"],
                ["Managing platforms one by one", "Sales across all channels"],
                ["Organising shipping and logistics", "Storage, logistics and shipping"],
                ["Checking invoices and incoming payments", "Processing and settlement"],
                ["Collecting proof and records", "Documentation and recycling proof"],
            ],
            routesLabel: "Routes to market",
            routesTitle: "For every part, the route with the best return.",
            routesText: "If a channel does not deliver the expected return, we switch in agreement with you.",
            transparencyLabel: "Transparency",
            transparencyTitle: "You always see where every part stands.",
            transparency: [
                { title: "Status of every position", text: "Captured, offered, sold or recycled. Visible at any time in the customer portal." },
                { title: "Costs and return", text: "All costs and the net return, openly side by side." },
                { title: "Monthly settlement", text: "Ready for accounting and controlling, position by position." },
            ],
            safetyLabel: "Your security",
            safetyTitle: "Clear rules from day one.",
        },
        stock: {
            eyebrow: "Your inventory",
            title: "Every inventory is different. The process stays simple.",
            sub: "Choose your starting point and see how Parto handles exactly this case.",
            sortLabel: "Sort first, then sell",
            sortTitle: "Critical parts stay. The rest gets a route.",
            sortText: "Together with you, we separate what stays from what can go. Supply to your equipment remains secured.",
            sortGroups: ["Keep", "Release", "Recycle"],
            sortItems: [
                { name: "Servo motor", meta: "4 units · unmoved since 2019", img: "servomotor", group: 1, reason: "No longer needed, in demand" },
                { name: "Electric motor", meta: "2 units · line 2", img: "elektromotor", group: 0, reason: "Reserve for a running machine" },
                { name: "Valve terminal", meta: "12 units · project surplus", img: "ventilinsel", group: 1, reason: "As new, in original packaging" },
                { name: "Rolling bearing", meta: "40 units · maintenance", img: "waelzlager", group: 0, reason: "Critical, long lead time" },
                { name: "Gear wheel", meta: "18 units · discontinued", img: "zahnrad", group: 1, reason: "Wanted for legacy machines" },
                { name: "Gearbox", meta: "1 unit · defective", img: "getriebe", group: 2, reason: "Repair not economical" },
                { name: "Flange", meta: "6 units · special part", img: "flansch", group: 1, reason: "Dealers in the network interested" },
            ],
            sortListTitle: "Inventory list",
            sortChecked: "checked",
            sortPending: "Not checked",
            sortSummary: "Result of the review",
            sortAgain: "Check again",
            cardsLabel: "Starting points",
            cardsTitle: "Choose your starting point.",
            cards: [
                { title: "Surplus stock", text: "More in stock than you need. We bring the surplus back to the market.", to: "/solutions/surplus-excess", img: "/media/parto/paletten-folie.jpg" },
                { title: "Spare parts", text: "Secure critical parts, release true surplus.", to: "/solutions/mro-spare-parts", img: "/media/parto/kugellager.jpg" },
                { title: "Obsolete parts", text: "Slow movers and discontinued parts. We realise the residual value.", to: "/solutions/obsolete-slow-moving", img: "/media/parto/werkhalle-alt.jpg" },
                { title: "Plant closure", text: "A site closes or moves. We clear it on a fixed schedule.", to: "/solutions/plant-closures", img: "/media/parto/werkhalle-maschinen.jpg" },
            ],
            more: "Learn more",
            rolesLabel: "For your role",
            rolesTitle: "What it means for you.",
            roles: [
                { title: "Procurement and materials management", text: "Less surplus, more transparency. And you source spare parts for less through HubParto." },
                { title: "Maintenance", text: "Critical parts stay available. Only true surplus is released." },
                { title: "Finance and controlling", text: "Tied up capital becomes liquidity again. With an auditable statement per position." },
                { title: "Plant and general management", text: "Space is freed up and your staff are relieved. One point of contact for the entire project." },
            ],
            directLabel: "Sell directly",
            directLinks: [
                { label: "Sell industrial inventory", to: "/solutions/sell-industrial-inventory" },
                { label: "Sell surplus inventory", to: "/solutions/sell-surplus-inventory" },
                { label: "Sell machinery and equipment", to: "/solutions/sell-machinery-equipment" },
                { label: "Clear a site or plant", to: "/solutions/plant-closures-restructuring" },
            ],
        },
        references: {
            eyebrow: "References",
            title: "We present our references to you in person.",
            sub: "Our customers stay anonymous. We only show projects with their consent and are glad to go into detail in a personal meeting.",
            cta: "Request references",
            numbersLabel: "Parto in numbers",
            numbersTitle: "What stands behind our network.",
            casesLabel: "Sample projects",
            casesTitle: "Four projects from practice, anonymised.",
            cases: [
                { tag: "Plant closure", title: "A plant cleared on schedule.", text: "Three halls captured, sold and handed over swept clean.", img: "/media/parto/werkhalle-maschinen.jpg", facts: [] },
                { tag: "Spare parts store", title: "Store cleaned up, equipment secured.", text: "Reviewed together with maintenance. Critical items stayed, the surplus went on sale.", img: "/media/parto/pruefen-messschieber.jpg", facts: [] },
                { tag: "Surplus", title: "Old material, new buyers.", text: "A year's worth of material, freed up by a product change. Sold to buyers across Europe.", img: "/media/parto/paletten-halle.jpg", facts: [] },
                { tag: "Legacy stock", title: "Discontinued controls sold.", text: "Controls and drives that are no longer manufactured. In demand at plants with older lines.", img: "/media/parto/komponenten.jpg", facts: [] },
            ],
            casesNote: "Sample projects without client names. Preliminary figures, pending approval.",
            productsLabel: "What we bring to market",
            productsTitle: "From a single sensor to an entire plant.",
            products: [
                "PLC and control technology",
                "HMI and operator panels",
                "Frequency inverters and drives",
                "Servo and electric motors",
                "Sensors",
                "Pneumatics",
                "Industrial PCs and electronics",
                "Power supplies and machine spare parts",
                "Robotics",
                "Machinery and equipment",
            ],
            situationsLabel: "Typical projects",
            situationsTitle: "These are the situations behind our assignments.",
            situations: [
                { title: "Surplus after a production change", text: "Material for a discontinued product is still in stock and goes back to the market." },
                { title: "Clean up a spare parts store", text: "Stock that has grown over years is reviewed. Critical parts stay, surplus is sold." },
                { title: "Legacy automation stock", text: "Discontinued controllers and drives find buyers who still need exactly these parts." },
                { title: "Clear a site", text: "Machinery, equipment and spare parts are captured and handled on a fixed schedule." },
            ],
            note: "We will publish approved projects here with our customers' consent.",
        },
        about: {
            eyebrow: "About Parto",
            title: "Industrial parts should keep their value.",
            sub: "Even when a company no longer needs them. Parto connects marketplaces, warehouse and data and finds the best route for every part.",
            quote: "We start where others stop.",
            quoteBy: "Artur Schlee · Managing Director",
            valuesLabel: "How we work",
            valuesTitle: "Five values you can hold us to.",
            values: [
                { title: "Think in systems", text: "We look at the entire process before we make an offer." },
                { title: "Stay close to the part", text: "We inspect inventory on site and only assess what we know." },
                { title: "Return comes first", text: "We recommend the best route and say openly when a sale is not worth it." },
                { title: "Work repeatably", text: "What works in the first project becomes the standard for the next." },
                { title: "Full transparency", text: "You can follow every step, every assessment and every decision." },
            ],
            networkLabel: "Parto Netzwerk",
            networkTitle: "Four brands, one process.",
            networkText: "The part decides which brand is used. Value before channel.",
            brands: [
                { name: "Parto Solution", role: "Takeover", text: "Takes over released inventory, captures it and manages the next steps.", href: null },
                { name: "HubParto", role: "Online shop", text: "Automation technology and spare parts from stock, for business customers worldwide.", href: "https://hubparto.com/en/" },
                { name: "Parto Assets", role: "Tenders", text: "Closed tenders for machinery, equipment and lots to verified dealers.", href: "https://partoassets.com/en/" },
                { name: "BuyParto", role: "Purchase", text: "Instant purchase when speed matters. Fixed price, collection from your site.", href: "https://www.buyparto.com/" },
            ],
            teamLabel: "Who is behind it",
            teamTitle: "Industrial experience, based in Münsterland, Germany.",
            leadLabel: "Management",
            leads: ["Artur Schlee", "Paul Seemann"],
            locationLabel: "Location",
            location: "Stadtforst 3 · 48432 Rheine · Germany",
            moreLabel: "More about Parto",
        },
        network: {
            eyebrow: "Network and channels",
            title: "Four routes to market. One point of contact.",
            sub: "Individually through HubParto, by tender through Parto Assets, as an instant purchase through BuyParto or through our partner network.",
            channelsLabel: "Our channels",
            channelsTitle: "The right marketplace for every part.",
            channels: [
                { name: "HubParto", role: "Online shop", text: "Automation technology and spare parts from stock, worldwide for business customers.", fit: "For parts in demand", img: "/media/parto/paket.jpg", href: "https://hubparto.com/en/" },
                { name: "Parto Assets", role: "Tenders", text: "Closed tenders for machinery, equipment and larger lots.", fit: "For lots and machinery", img: "/media/parto/paletten-rampe.jpg", href: "https://partoassets.com/en/" },
                { name: "BuyParto", role: "Purchase", text: "Our brand for instant purchase. BuyParto buys stock directly, at a fixed price and with collection.", fit: "When speed matters", img: "/media/parto/stapler-verladung.jpg", href: "https://www.buyparto.com/" },
                { name: "Parto Network", role: "Partners", text: "Dealers, logistics and recycling partners who work closely with us.", fit: "For everything that needs a specialist", img: "/media/parto/stapler-transporter.jpg", to: "/partners" },
            ],
            visit: "Visit",
            principleLabel: "Our principle",
            principleTitle: "Value before channel.",
            principleText: "Condition, demand and achievable return decide where a part is sold.",
            partnerTitle: "Want to join the network?",
            partnerText: "For dealers, buyers, logistics and recycling.",
            partnerCta: "Become a partner",
        },
        partners: {
            eyebrow: "Become a partner",
            title: "Bringing more parts back to market, together.",
            sub: "For dealers, buyers, logistics and recycling. Checked goods for reliable partners.",
            cta: "To the request",
            typesLabel: "Who it is for",
            typesTitle: "Four ways to work together.",
            types: [
                { id: "sales", title: "Sales and trade", text: "You sell industrial parts and want access to more goods." },
                { id: "buyer", title: "Dealers and buyers", text: "You buy used or surplus parts and want to bid in tenders." },
                { id: "logistics", title: "Logistics", text: "You transport, store or pack industrial goods." },
                { id: "recovery", title: "Recycling", text: "You recycle parts that can no longer be sold, properly and with proof." },
            ],
            choose: "Send a request",
            stepsLabel: "How it works",
            stepsTitle: "Four steps to working together.",
            steps: [
                { num: "01", title: "Send a request", text: "Fill in the short form below." },
                { num: "02", title: "Get to know each other", text: "We talk about your offer, your markets and your needs." },
                { num: "03", title: "Start", text: "Together we agree how we will work." },
                { num: "04", title: "Work together", text: "You receive matching goods, requests or orders." },
            ],
            formLabel: "Your request",
            formTitle: "Tell us briefly about your company.",
            formText: "We will get back to you personally.",
        },
        careers: {
            detail: {
                back: "All positions",
                mission: "Your role",
                own: "What you take on",
                bring: "What you bring",
                nice: "Nice to have",
                expect: "What to expect",
                process: "How applying works",
                processSteps: ["Application", "First call", "Meeting on site", "Decision"],
                apply: "Apply",
                applyTitle: "Sounds like you?",
                applyText: "A few lines and your CV are enough. No cover letter needed.",
                words: {},
            },
            eyebrow: "Careers",
            title: "Work where industrial parts get a second life.",
            sub: "Parto is growing. We are looking for people who get things done and take responsibility. In Rheine, Germany.",
            cta: "Open positions",
            whyLabel: "Why Parto",
            whyTitle: "What to expect with us.",
            why: [
                { title: "Real responsibility", text: "You help shape processes that do not exist in this form yet." },
                { title: "Close to practice", text: "Warehouse, customers and market: you see every day what your work achieves." },
                { title: "A team that sticks together", text: "Short paths, clear agreements and a shared goal." },
            ],
            jobsLabel: "Open positions",
            jobsTitle: "This is where we need support right now.",
            jobMore: "View position",
            openTitle: "Nothing suitable?",
            openText: "Send us a speculative application. We will get back to you.",
            openCta: "Apply speculatively",
        },
        contact: {
            eyebrow: "Contact",
            title: "Tell us what it is about.",
            sub: "A few details are enough. You will receive a well founded first assessment from us.",
            intentLabel: "Your request",
            intentTitle: "How can we help?",
            intents: [
                { id: "assets", name: "Stock", title: "I want to release inventory.", desc: "Surplus, legacy stock, spare parts or a whole site.", chips: ["Surplus", "Legacy", "Spare parts", "Plant"], cta: "Request stock review" },
                { id: "operations", name: "Handling", title: "I need support with storage and handling.", desc: "Capture, store, pack, ship. We take over the operational work around your inventory.", chips: ["Capture", "Storage", "Shipping"], cta: "Request handling" },
                { id: "partnership", name: "Partnership", title: "I want to work with Parto.", desc: "As dealer, buyer, logistics or recycling partner.", chips: ["Trade", "Buying", "Logistics", "Recycling"], cta: "Become a partner" },
                { id: "general", name: "General", title: "I have another question.", desc: "Press, suppliers or any other matter.", chips: [], cta: "Send message" },
            ],
            contactSection: "Your contact details",
            situationSection: "Your situation",
            situations: [
                { id: "surplus", label: "Surplus stock" },
                { id: "obsolete", label: "Legacy stock and slow movers" },
                { id: "mro", label: "Spare parts" },
                { id: "closure", label: "Plant closes or is restructured" },
                { id: "transfer", label: "Production is moving" },
                { id: "other", label: "Something else" },
            ],
            assetTypesLabel: "Which parts are included?",
            assetTypes: ["Automation", "Electrical", "Drives and motors", "Mechanics", "Spare parts", "Machines and equipment", "Mixed", "Other"],
            releasedLabel: "Has the stock already been released internally?",
            opsNeedsLabel: "Where should we support you?",
            opsNeeds: ["Takeover", "Capture", "Preparation", "Storage", "Inventory", "Packing", "Shipping", "Multiple channels", "Goods in and out", "Other"],
            uploadTitle: "Have an inventory list?",
            uploadClaim: "Upload your inventory list or photos.",
            uploadDesc: "An Excel file, an ERP export or a few photos are enough. It helps us assess faster.",
            uploadCta: "Choose files",
            uploadHint: "XLSX, XLS, CSV, PDF, DOCX, JPG, PNG · up to 10 MB each · max. 5 files",
            uploadNote: "The key details are enough for a first assessment.",
            messagePhGeneral: "What is it about?",
            sending: "Sending",
            successTitle: "Thank you, your request has been received.",
            successText: "We review your details and get back to you with a first assessment.",
            wayLabel: "What matters more to you?",
            ways: [
                { id: "sale", title: "Highest return", desc: "Sale on your behalf via Parto" },
                { id: "buy", title: "Fast payout", desc: "Instant purchase via BuyParto" },
                { id: "advice", title: "Advise me", desc: "We recommend the right route for you" },
            ],
            wayPrefix: "Route",
            wayLines: { sale: "Sale on your behalf via Parto (highest return)", buy: "Instant purchase via BuyParto", advice: "Advice requested" },
            successBuy: "Your request goes directly to the BuyParto purchasing team.",
            partnerLabel: "Partnership",
            partnerTitle: "How would you like to work with us?",
            partnerCards: [
                { id: "sales", name: "Sales and trade", tagline: "You sell industrial parts and want more goods." },
                { id: "buyer", name: "Dealers and buyers", tagline: "You look for used or surplus parts." },
                { id: "logistics", name: "Logistics", tagline: "You transport, store or pack." },
                { id: "recovery", name: "Recycling", tagline: "You recycle properly and with proof." },
            ],
            partnerCta: "Go to the request",
            directLabel: "Prefer direct?",
            directTitle: "Write to us.",
            locationLabel: "Location",
            locationTitle: "Storage, preparation and your contact in one place.",
            entLabel: "Several sites",
            entTitle: "For larger programmes we plan together.",
            entDesc: "Several plants or recurring stock? We define one consistent approach for every site.",
            entCta: "Discuss a programme",
            fields: { websitePh: "https://… (optional)", phonePh: "+49 5971 9629031" },
            funnel: { labelSituation: "Situation", labelAssetTypes: "Parts", intentHint: "Please choose a request first.", detailsHint: "Please fill in the required fields." },
        },
        routeMap: {
            source: "Released stock",
            gate: "Parto",
            gateSub: "finds the best route for every part",
            channels: [
                { brand: "HubParto", name: "HubParto", sub: "Single sale" },
                { brand: "Parto Assets", name: "Parto Assets", sub: "Larger lots" },
                { brand: "BuyParto", name: "BuyParto", sub: "Purchase" },
                { name: "Network", sub: "Dealers and partners" },
                { name: "Recycling", sub: "Recycling with proof" },
            ],
            aria: "Animation: parts from released stock flow through Parto into the right channels: HubParto, Parto Assets, BuyParto, network and recycling.",
        },
        testimonials: {
            label: "Customer voices",
            title: "What our customers say.",
            ratingLabel: "Overall rating",
            clientsLabel: "References",
            clientsTitle: "These companies work with Parto.",
            logoPlaceholder: "Logo",
            clientsEyebrow: "Companies working with Parto",
            clientsNote: "Placeholder: legal approval required.",
            of5: "out of 5 stars",
            from: "from",
            reviews: "reviews",
            carousel: "Carousel",
            slide: "Slide",
            pause: "Pause slideshow",
            play: "Start slideshow",
            prev: "Previous slide",
            next: "Next slide",
            pauseTicker: "Pause ticker",
            playTicker: "Start ticker",
            placeholderNote: "Placeholder: voices, rating and logos will be replaced once customers approve.",
        },
        footer: {
            tagline: "Parto handles the storage and sale of industrial inventory you no longer need.",
            colHow: "Process",
            howLinks: [
                { label: "How we work", to: "/how-it-works" },
                { label: "Routes to market", to: "/how-it-works#wege" },
                { label: "Your security", to: "/how-it-works#sicherheit" },
                { label: "References", to: "/references" },
            ],
            colStock: "Your inventory",
            colSell: "Sell directly",
            colAbout: "About Parto",
            contact: "Contact",
            colChannels: "Our channels",
            bottomLine: "Keeping industrial inventory in use.",
        },
        titles: {
            "/how-it-works": "How we work",
            "/solutions": "Your inventory",
            "/references": "References",
            "/company": "About Parto",
            "/sustainability": "Sustainability and circular economy",
            "/brands": "Our brands",
            "/location": "Location and warehouse",
            "/quality": "Quality and security",
            "/services": "Services",
            "/industries": "Industries",
            "/news": "Press and news",
            "/": "Sell industrial inventory professionally",
            "/ecosystem": "Network and channels",
            "/partners": "Become a partner",
            "/careers": "Careers",
            "/solutions/surplus-excess": "Surplus stock",
            "/solutions/mro-spare-parts": "Spare parts",
            "/solutions/obsolete-slow-moving": "Obsolete parts",
            "/solutions/plant-closures": "Plant closure",
            "/solutions/sell-industrial-inventory": "Sell industrial stock",
            "/solutions/sell-surplus-inventory": "Sell surplus stock",
            "/solutions/sell-machinery-equipment": "Sell machines and equipment",
            "/solutions/plant-closures-restructuring": "Clear a site or plant",
            "/contact": "Contact",
            "/impressum": "Imprint",
            "/datenschutz": "Privacy",
            "/llm-info": "Information for AI systems",
        },
        notFound: {
            eyebrow: "Error 404",
            title: "This page does not exist.",
            text: "The address may have changed. These pages will help:",
            home: "Go to homepage",
        },
    },
};
